<script setup>
import { useArticleImport } from "@/components/ExternalApps/SalesChannelManagementApp/composables/useArticleImport";

const {
  runCFLWorkflow,
  showArticleImportModal,
  xentralArticleStock,
  showArticleImportPrepareModal,
  hasErrorMessage,
  xentralArticleErrorMessage
} = useArticleImport();
</script>

<template>
  <div class="text-center">
    <div class="">
      <div v-if="!hasErrorMessage" class="font-weight-bold mb-2">
        {{
          $t("salesChannelManagementApp.journal.articleFound", {
            stock: xentralArticleStock
          })
        }}
      </div>
      <div>
        <template v-if="!hasErrorMessage">
          {{ $t("salesChannelManagementApp.journal.articleListExportInfo") }}
        </template>
        <template v-else>
          <div class="alert alert-danger bg-white mb-0 text-left">
            <i class="fal fa-warning"></i>
            <div class="ml-4">
              <strong>{{
                $t("salesChannelManagementApp.journal.articleFoundError")
              }}</strong>
              <p class="mb-0">
                {{ xentralArticleErrorMessage }}
              </p>
            </div>
          </div>
        </template>
      </div>
      <div v-if="!hasErrorMessage" class="d-flex mt-8">
        <button
          class="btn btn-outline-secondary w-50"
          @click="
            showArticleImportModal = false;
            showArticleImportPrepareModal = false;
          "
        >
          {{ $t("general.cancel") }}
        </button>
        <button class="btn btn-primary w-50 ml-2" @click="runCFLWorkflow">
          {{ $t("salesChannelManagementApp.journal.createArticleList") }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
